import Grid from '@mui/material/Grid2'
import { Container, useMediaQuery } from '@mui/material'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { formulationsBanner, ProjectingEfficacy, CharacteristicsCompatibilities, PromotionTool, ClientSupport, FormulationProduct1, FormulationProduct2, FormulationProduct3, FormulationProduct4, FormulationProduct5, Mission, Headset, DataHistogram, Notebook, Packaging, Training, Conferences, Goal } from '../../helpers/constant/imageUrl'
import './formulations.scss'
import FormulationSlider from './FormulationSlider'

const FormulationsTemplate = () => { 
    return (
        <div className="formulations">
            <div className='gradient-section'>
                <div className='pattern'>
                    <img src={formulationsBanner} alt='pattern' />
                </div>
                <Container className='container'>
                    <Grid container justifyContent={'center'}>
                        <Grid size={{ xs: 12, md: 8  }}>
                            <h1>Formulations</h1>
                            <p>Our formulation Team is dedicated to enhancing the efficacy and marketability of our products by showcasing their optimal use and benefits.</p>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className='blue-section'>
                <Container className='container'>
                    <Grid container justifyContent={ { xs: 'space-between', sm: 'center', md: 'space-between' }} spacing={{ xs: 2, md: 3 }}>
                        <Grid size={{ xs: 12, sm: 4, md: 3 }}>
                            <div className='thumb'>
                                <img src={ProjectingEfficacy} alt='ProjectingEfficacy' />
                                <div className='overlay'>
                                    <h1>Projecting<br/> Efficacy</h1>
                                    <p>We highlight the effectiveness of our active ingredients, demonstrating how they can be used to achieve maximum efficacy.</p>
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4, md: 3 }}>
                            <div className='thumb'>
                                <img src={CharacteristicsCompatibilities} alt='CharacteristicsCompatibilities' />
                                <div className='overlay'>
                                    <h1>Characteristics & Compatibilities</h1>
                                    <p>Our formulations provide insights into the various characteristics of active chemicals and their compatibilities with other substances.</p>
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4, md: 3 }}>
                            <div className='thumb'>
                                <img src={PromotionTool} alt='PromotionTool' />
                                <div className='overlay'>
                                    <h1>Promotion<br/> Tool</h1>
                                    <p>The department serves as a powerful tool to promote our active chemicals, helping clients understand and appreciate the ingredient through practical applications</p>
                                </div>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4, md: 3 }}>
                            <div className='thumb'>
                                <img src={ClientSupport} alt='ClientSupport' />
                                <div className='overlay'>
                                    <h1>Client<br/> Support</h1>
                                    <p>We help clients experience and understand the benefits of our ingredients by providing comprehensive formulation samples.</p>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className='capabilities'>
                <Container className='container'>
                    <div className='pattern'>
                        <img src={formulationsBanner} alt='formulationsBanner' />
                    </div>
                    <h1>Capabilities</h1>
                    <p>Our Formulation Department is adept at creating a wide range of cosmetics and personal care products. We specialize in formulation chemistry, which involves combining non-reactive substances to createeffective final products. For instance, our anti-ageing cream formulation includes Bakuchiol, Emulsifiers,Emollients, Humectants, Preservatives, and Fragrances.</p>
                    <h3>Infrastructure</h3>
                    <ul>
                        <li>Homogenizer</li>
                        <li>IKA reactor</li>
                        <li>Refrigerator</li>
                        <li>Centrifuge</li>
                    </ul>
                </Container>
            </div>
            <div className='accordion-section'>
                <Container className='container'>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Patents
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={{ xs: 12, md: 10 }}>
                                <Grid size={{ xs: 12, md: 'auto' }}>
                                    <h3>We have filed several patents for our innovative formulations:</h3>
                                    <ul>
                                        <li>Carrot Dew with Kopcarotol</li>
                                        <li>No Scar with Kopalleum</li>
                                        <li>Hair Wipe with Kopcolate</li>
                                    </ul>
                                </Grid>
                            </Grid>             
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            Innovative Blends
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={{ xs: 5, md: 10 }}>
                                <Grid size={{ xs: 12, md: 'auto' }}>
                                    <ul>
                                        <li>Preservative Blends Products like KOPTBC, KOPBOB, KOPROPOCTPG, KOPPO11, KOPCP, KOPCK ,KOPOH, KOPCERIN BA</li>
                                        <li>Surfactant Blends</li>
                                        <li>Natural Moisturizing Factor Blends</li>
                                        <li>Bioferment Blends with Actives</li>
                                    </ul>
                                </Grid>
                            </Grid>             
                        </AccordionDetails>
                    </Accordion>
                </Container>
            </div>
            <div className='formulation-products' style={{background:"white"}} >
                 {/* <Container className='container'>
                    <h3>Our Formulation Products</h3>
                    <Grid container justifyContent={'space-between'} spacing={{ xs: 2, md: 3 }}>
                        <Grid size={{ xs: 12, sm: 2.4, md: 2.4 }}>
                            <img src={FormulationProduct1} alt='' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 2.4, md: 2.4 }}>
                            <img src={FormulationProduct2} alt='' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 2.4, md: 2.4 }}>
                            <img src={FormulationProduct3} alt='' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 2.4, md: 2.4 }}>
                            <img src={FormulationProduct4} alt='' />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 2.4, md: 2.4 }}>
                            <img src={FormulationProduct5} alt='' />
                        </Grid>
                    </Grid>
                </Container>  */}
                <h3>Our Formulation Products</h3>
                <FormulationSlider/>
            </div>
            <div className='innovation-services'>
                <Container className='container'>
                    <Grid container justifyContent="space-between" spacing={{ xs: 5, md: 3 }}>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <div className='white-card'>
                                <div className='icon-holder'>
                                    <img src={Mission} alt='Mission' />
                                </div>
                                <h4>New Concept Development</h4>
                                <p>Creating innovative product formats using KOPL actives to demonstrate current market trends.</p>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <div className='white-card'>
                                <div className='icon-holder'>
                                    <img src={Headset} alt='Headset' />
                                </div>
                                <h4>Technical Support</h4>
                                <p>Assisting the sales and marketing team to meet client requirements with technical expertise.</p>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <div className='white-card'>
                                <div className='icon-holder'>
                                    <img src={DataHistogram} alt='DataHistogram' />
                                </div>
                                <h4>Research Mapping</h4>
                                <p>Mapping formulations based on marketing research databases.</p>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <div className='white-card'>
                                <div className='icon-holder'>
                                    <img src={Notebook} alt='Notebook' />
                                </div>
                                <h4>Studies & Testing</h4>
                                <p>Conducting Stability, Compatibility, Clinical Studies, and Dermatological Testing.</p>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <div className='white-card'>
                                <div className='icon-holder'>
                                    <img src={Packaging} alt='Packaging' />
                                </div>
                                <h4>Innovative Packaging</h4>
                                <p>Exploring new packaging solutions for enhanced product presentation.</p>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <div className='white-card'>
                                <div className='icon-holder'>
                                    <img src={Training} alt='Training' />
                                </div>
                                <h4>Training & Education</h4>
                                <p>Providing training on active ingredients and participating in webinars and seminars.</p>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <div className='white-card'>
                                <div className='icon-holder'>
                                    <img src={Conferences} alt='Conferences' />
                                </div>
                                <h4>Conferences & Exhibitions</h4>
                                <p>Engaging in national and international conferences and exhibitions to showcase our product.</p>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                            <div className='white-card'>
                                <div className='icon-holder'>
                                    <img src={Goal} alt='Goal' />
                                </div>
                                <h4>Sample Provision</h4>
                                <p>Supplying formulation samples to the sales and marketing team and for exhibitions.</p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
            </div>
            <div className='evaluation-panel'>
                <Container className='container'>
                    <h3>Internal Evaluation Panel</h3>
                    <p>We conduct comprehensive non-technical assessments to ensure our products meet the highest standards of consumer satisfaction. This evaluation covers key sensory attributes including aesthetics, oiliness, tackiness, smoothness, absorption and odor. By meticulously assessing these factors, we ensure that our formulations not only perform effectively but also provide an optimal user experience.</p>
                    <p>Additionally, we conduct depilatory evaluations to guarantee the efficacy and safety of our hair removal products. This thorough approach allows us to deliver high-quality products that meet the diverse needs and preferences of our customers.</p>
                </Container>
            </div>
            <div className='innovative-trend'>
                <Container className='container'>
                    <Grid container justifyContent="space-between" spacing={{ xs: 5, md: 11 }}>
                        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                            <h2>Innovative Trends in Formulation</h2>
                            <p>We conduct comprehensive non-technical assessments to ensure our products meet the highest standards of consumer satisfaction. This evaluation covers key sensory attributes including aesthetics, oiliness, tackiness, smoothness, absorption and odor. By meticulously assessing these factors, we ensure that our formulations not only perform effectively but also provide an optimal user experience.</p>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    Skinimalism
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>Multifunctional products like Anti-Ageing Cream with Bakuchiol and BB cream.</p>            
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    Waterless Formulations
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>Sustainable products like Shampoo Tablets, Conditioning Bars, Mouthwash Tablets, and Depilatory Tablets.</p>            
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    Biocosmetics
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>Products like Carrot Dew, Skin Essence, and Skin Glow and Radiance Cream.</p>            
                                    <p>Anti-Stress Skin Care: Products designed to reduce stress effects on the skin.</p>            
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    Anti-pollution Products
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>Formulations that protect against environmental pollutants.</p>           
                                </AccordionDetails>
                            </Accordion>
                            <Accordion>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    Cosmetic Strips
                                </AccordionSummary>
                                <AccordionDetails>
                                    <p>Innovative products using Pullulan, such as Face Wash Strips.</p>           
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </div>
    )
}

export default FormulationsTemplate